import React, { FC, ReactNode } from 'react';
import cn from 'classnames';
import CustomScroll from 'react-custom-scroll';
import { connect } from 'react-redux';

import { toggleLegend } from '@store/actions';
import arrowUp from '@assets/arrow-up.svg';
import { legendVisibilitySelector } from '@selectors/uiSelector';
import useDeviceType from '@hooks/useDeviceType';
import st from './MapLegend.module.css';

type MapLegendProps = {
  big?: boolean;
  children?: ReactNode;
  toggle: () => void;
  visibility?: boolean;
};

const MapLegend: FC<MapLegendProps> = ({
  big = false,
  children = null,
  toggle,
  visibility = false,
}) => {
  const { tablet, desktop } = useDeviceType();
  const isNoScrollNeeded = !desktop && big;
  const showToggleBtn = children && (desktop || (tablet && !big));

  const cnWrapper = cn(st.wrapper, {
    [st.wrapperHide]: visibility && !big,
    [st.wrapperHideBig]: visibility && big,
    [st.wrapperBig]: big,
    [st.wrapperWithoutScroll]: isNoScrollNeeded,
  });

  const cnToggle = cn(st.btnToggleHide, {
    [st.btnToggleShow]: visibility,
  });

  const cnToggleImg = cn(st.btnToggleHideImg, {
    [st.btnToggleShowImg]: visibility,
  });

  return (
    <div className={cnWrapper}>
      {isNoScrollNeeded ? (
        <div className={st.noScrollWrapper}>
          <div className={st.main}>{children}</div>
        </div>
      ) : (
        <CustomScroll heightRelativeToParent="100%" allowOuterScroll>
          <div className={st.main}>{children}</div>
        </CustomScroll>
      )}
      {showToggleBtn && (
        <button className={cnToggle} type="button" onClick={toggle}>
          <img className={cnToggleImg} src={arrowUp} alt="toggle visibility" />
        </button>
      )}
    </div>
  );
};

export default connect(
  (state) => ({
    visibility: legendVisibilitySelector(state),
  }),
  (dispatch) => ({
    toggle: () => dispatch(toggleLegend()),
  })
)(MapLegend);
